import CostumeDisplay from './CostumeDisplay';

export default CostumeDisplay;
